import apiRequest from '@/apiRequest'
import { AxiosResponse } from 'axios'
import ApiRequestPaths from '@/apiRequestPaths'

export interface CatalogItemsLink {
  context: string,
  instanceId: string,
  mainCatalogId: string,
  mainCatalogItemId: string,
  subCatalogId: string,
  subCatalogItemId: string,
}

export interface CatalogItemsLinks {
  links: Array<CatalogItemsLink>,
}

export interface LinkedItem {
  id: string,
  title: string,
  link: string,
  imageLink: string,
}

export class CatalogItemsLinkerApiRequest {
    static linkItems(catalogItemsLink: CatalogItemsLink): Promise<AxiosResponse<CatalogItemsLinks>> {
      return apiRequest.post<CatalogItemsLinks>(ApiRequestPaths.LINK_CATALOG_ITEMS, catalogItemsLink)
    }

    static detachItems(catalogItemsLink: CatalogItemsLink): Promise<AxiosResponse<CatalogItemsLinks>> {
      return apiRequest.post<CatalogItemsLinks>(ApiRequestPaths.DETACH_CATALOG_ITEMS, catalogItemsLink)
    }

    static getLinkedItems(context: string, instanceId: string, subCatalogId: string, mainCatalogItemId: string): Promise<AxiosResponse<any>> {
      return apiRequest.get<any>(ApiRequestPaths.GET_LINKED_CATALOG_ITEMS.replace('{context}', context).replace('{instanceId}', instanceId).replace('{subCatalogId}', subCatalogId).replace('{mainCatalogItemId}', mainCatalogItemId))
    }

    static getLinkedItemsIds(context: string, instanceId: string, mainCatalogItemId: string): Promise<AxiosResponse<any>> {
      return apiRequest.get<any>(ApiRequestPaths.GET_LINKED_CATALOG_ITEMS_IDS.replace('{context}', context).replace('{instanceId}', instanceId).replace('{mainCatalogItemId}', mainCatalogItemId))
    }

    static getAllLinkedItemsIds(context: string, instanceId: string): Promise<AxiosResponse<any>> {
      return apiRequest.get<any>(ApiRequestPaths.GET_ALL_LINKED_CATALOG_ITEMS_IDS.replace('{context}', context).replace('{instanceId}', instanceId))
    }
}